module.exports = __webpack_public_path__ + "img/532m1.a84016cd.svg";